<template>
<div class="page page_order page_order_detail">
	<!-- 物流信息 -->
    <div class="wuliu" v-if="logsticsList&&logsticsList.length>0">
        <div class="wuliu_t">物流信息</div>
        <div class="wuliu_item clearfix" v-for="logstics in logsticsList" :key="logstics.id">
            <div class="wuliu_item_l f-l">{{logstics.time}}</div>
            <div class="wuliu_item_r f-l">{{logstics.description}}</div>
        </div>
    </div>
    <!-- 地址区域 -->
    <div class="item">
        <div class="adress">
            <div class="info" v-if="info != null">
                <div class="user">{{ info.person + ' ' + info.phone }}</div>
                <div class="dizhi">
                    {{ info.address }}
                </div>
            </div>
        </div>
    </div>
	<!-- 订单商品信息 -->
	<div class="list" v-if="info != null">
        <div class="item">
            <div class="item_t" @click="toTradsman">
                <div class="item_t_t">
                    <img :src="info.tradesman.thumb? ($publicData.withHttpStart(info.tradesman.thumb) ? info.tradesman.thumb :imageUrl+info.tradesman.thumb) :$publicData.defaultTouxiang" alt="" class="thumb" />
                    <div class="title">{{ info.tradesman.nickname }}</div>
                </div>
                <div class="status" >{{ orderStatus }}</div>
            </div>
            <div class="item_nr" @click="toGoodsDetail(info.made)">
                <div class="item_nr_l">
					<van-image :src="info.made.thumb?imageUrl+info.made.thumb:$publicData.intangibleDefault" class="tu" fit="cover" />
                    <!-- <img :src="info.made.thumb?info.made.thumb:$publicData.intangibleDefault" alt="" class="tu" /> -->
                </div>
                <div class="item_nr_r dingzhi" >
					<div class="info">
						<div class="title slh">{{ info.made.title }}</div>
						<div class="desc slh">{{ info.made.descript }}</div>
					</div>
					<div class="jiage"><span class="nums f-r">{{ info.num ? 'x'+ info.num : 'x'+ 1 }}</span></div>
                </div>
            </div>
            <div class="item_extra">
                <div class="item_extra_l">邮费</div>
                <!-- <div class="item_extra_r">{{ orderDetail.fare }}</div> -->
				<div class="item_extra_r">￥{{ info.fare }}</div>
            </div>
			<!-- <div class="item_extra" v-if="discount && discount != 0">
                <div class="item_extra_l">折扣</div>
                <div class="item_extra_r">{{ dazhe }}</div>
            </div> -->
			<!-- <div class="item_extra shifu" v-if="dikouObj.user_money || dikouObj.chargecard  || dikouObj.parkscore_money && dikouObj.parkscore_money != 0">
				<span class="shifu_item" v-if="dikouObj.user_money">{{'余额抵扣: ' + dikouObj.user_money }}</span>
				<span class="shifu_item" v-if="dikouObj.chargecard">{{',' + '充值卡抵扣: ' + dikouObj.chargecard }}</span>
				<span class="shifu_item" v-if="dikouObj.parkscore_money">{{ '积分抵扣: ' + dikouObj.parkscore_money }}</span>
            </div> -->
			<div class="item_extra">
                <div class="item_extra_l">应付款</div>
                <div class="item_extra_r">
                    <div class="price"><span class="cash_tag">¥</span>{{ info.total_prices }}</div>
                </div>
            </div>
            <div class="item_extra">
                <div class="item_extra_l">预付款</div>
                <div class="item_extra_r">
                    <div class="price">
						<span class="cash_tag">¥</span>{{ info.deposit }}
						<span class="payStatus">{{ info.pay_status_deposit == 0 ? '未支付' : info.pay_status_deposit == 1 ? '支付中' :'已支付'}}</span>
					</div>
                </div>
            </div>
			<div class="item_extra">
                <div class="item_extra_l">尾款</div>
                <div class="item_extra_r">
                    <div class="price">
						<span class="cash_tag">¥</span>{{ info.final_payment }}
						<span class="payStatus">{{ info.pay_status_final == 0 ? '未支付' : info.pay_status_final == 1 ? '支付中' :'已支付'}}</span>
					</div>
                </div>
            </div>
			<div class="item_extra mark">
				<div class="mark_title">备注</div>
				<div class="mark_text">{{info.mark}}</div>
			</div>
        </div>
        <!-- 订单信息 -->
        <div class="item item_order" >
            <div class="title" >订单信息</div>
            <div class="order">
                <div class="">订单编号:{{ info.order_num }}</div>
                <div class="" v-for="pay in info.payorder" :key="pay.id">{{pay.type==1?'定金支付订单号':'尾款订单编号'}}: {{ pay.pay_order_num }}({{pay.pay_status==0?'未支付':'已支付'}})</div>
                <!-- <div class="">父订单编号:{{ pay.pay_order_num }}</div> -->
                <div class="">创建时间:{{ info.created_at }}</div>
                <!-- <div class="" v-if="orderDetail.pay_at">付款时间:{{ orderDetail.pay_at }}</div> -->
            </div>
        </div>
        <!-- 操作 -->
        <div class="actions">
			<div class="action" v-if="info.made_status == 1" @click="clickOrderMake">定制完成</div>
			<div class="action" v-if="info.made_status == 2 && info.ship_status == 0 && info.pay_status == 3" @click="showFahuo_overlay = true">发货</div>
			<div class="action" v-if="info.pay_status != 0 && info.order_status != 2" @click="toContactUser">联系客户</div>
        </div>
		<!-- 发货 -->
		<van-overlay :show="showFahuo_overlay" @click="showFahuo_overlay = false" />
		<div class="custom_info fahuo" v-if="showFahuo_overlay">
            <div class="info_top">
                <div class="info_title">发货</div>
                <img :src="publicPath+'statics/images/close_item.png'" alt="" class="info_close" @click="showFahuo_overlay = false">
            </div>
            <div class="info_nr">
                <div class="text">
                    <div class="text_info">
                        <div class="text_info_l">订单号：</div>
                        <div class="text_info_r">{{info.order_num}}</div>
                    </div>
                    <div class="text_info">
                        <div class="text_info_l">快递公司：</div>
                        <div class="text_info_r" @click="kuaidi_picker=true">
                            <van-field v-model="logistics_name" placeholder="请选择快递公司" readonly />
                        </div>
                    </div>
                    <div class="text_info">
                        <div class="text_info_l">快递单号：</div>
                        <div class="text_info_r">
                            <van-field v-model="logistics_code" placeholder="请填写快递单号" />
                        </div>
                    </div>
                    <div class="text_info">
                        <div class="text_info_l">店家备注：</div>
                        <div class="text_info_r">
                            <van-field v-model="shop_mark" placeholder="选填备注" />
                        </div>
                    </div>
					<div class="btn" @click="sendOrder">确认发货</div>
                </div>
            </div>
        </div>
		<!-- 快递列表 -->
        <van-popup v-model="kuaidi_picker" position="bottom">
            <van-picker title="选择快递" show-toolbar :columns="logisticsList" value-key="name" @confirm="confirmKuaidi" @cancel="kuaidi_picker=false" />
        </van-popup>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    // name: "my-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            active: 'a',
            id: this.$route.query.id,
            info: null,
            logsticsList: [],
			orderStatus:'',
			showFahuo_overlay: false,
			kuaidi_picker: false,
			logistics_name: null,
			logistics_code: null,
			shop_mark: null,
			logisticsList: null
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '定制订单详情'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
					this.getLogstics()
					this.getKuaidiList()
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.getData()
			this.getLogstics()
			this.getKuaidiList()
        }
    },
    methods: {
        // 获取列表
        getData() {
            var params = {
                token: this.token,
                id: this.id,
            }
			this.$api.dingzhi.orderDetail(params).then(res=>{
				if(res.code == 200){
                    this.info = res.result
                    if (this.info.made) {
                        var album = this.info.made.album
                        var images = album.split(",");
                        if (images.length > 0) {
                            this.info.made.thumb = images[0]
                        }
                    } else if (this.info.customizedcommunity) {
                            this.info.made = {
                                title: this.info.customizedcommunity.title,
                                descript:this.info.customizedcommunity.content,
                                price_range: this.info.customizedcommunity.price,
                                thumb: ''
                            }
                            var album = this.info.customizedcommunity.album
                            console.log(album)
                            var images = album.split(",");
                            if (images.length > 0) {
                                this.info.made.thumb = images[0]
                            } else {
                                this.info.made.thumb = ''
                            }
                        }
                    
					// 订单
                    if (this.info.order_status == 0) {
                        this.orderStatus = '已取消'
                    } else if (this.info.order_status == 2) {
                        this.orderStatus = '已完成'
                    } else if (this.info.pay_status == 0) {
                        this.orderStatus = '未付定金'
                    } else if (this.info.pay_status == 1) {
                        this.orderStatus = '支付中'
                    } else if (this.info.made_status == 1) {
                        this.orderStatus = '定制中'
                    } else if (this.info.pay_status == 2) {
                        this.orderStatus = '待付尾款'
                    } else if (this.info.receipt_status == 0) {
                        this.orderStatus = '待收货'
                    } else {
                        this.orderStatus = '已收货'
					}
					// 订单支付状态 定金 尾款
					for(var j in this.info.payorder){
						var pay = this.info.payorder[j]
						if(pay.type == 1){
							// 定金
							this.info.pay_status_deposit = pay.pay_status
							console.log()
						}else if(pay.type == 2){
							// 尾款
							this.info.pay_status_final = pay.pay_status
						}
					}
				} 
			})
        },
        getLogstics() {
            var token = this.$store.getters.token;
            var params = {
                token: this.token,
                id: this.id,
            }
			this.$api.dingzhi.logsticsList(params).then(res=>{
				if(res.code == 200){
                    this.logsticsList = res.result
				} 
			})
        },
		// 
		toTradsman(){
            if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
                var params = {
                    'data':{
                        'url':this.$publicData.clientUrl+'/art/detail?tradesmanId='+this.info.tradesman.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/detail',
                    query: {
                            tradesmanId: this.info.tradesman.id
                        }
                })
            }
		},
		// 定制详情
		toGoodsDetail(made){
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/dingzhi/detail?id=' + made.id + '&pay_status='+ this.info.pay_status_deposit
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/dingzhi/detail',
                    query: {
							id: made.id,
							pay_status: this.info.pay_status_deposit
                        }
                })
            }
        },
		// 定制完成
		clickOrderMake(){
			var that = this
			var params = {
				token: that.token,
				id: that.info.id,
				status: 2 // 定制状态 1定制中 2完成
			}
			that.$api.tradesman.ordermake(params).then(res=>{
				if(res.code == 200){
					that.$toast(res.message)
					// 重新刷新数据
					that.getData()
				}else{
                    that.$toast(res.message)
                    that.getData()
				}
			})
		},
		// 获取快递公司列表
        getKuaidiList() {
            var params = {
                token: this.token,
                page: 1,
                size: 10000
            }
            this.$api.tradesman.kuaidiList(params).then(res => {
                if (res.code == 200) {
                    this.logisticsList = res.result.list
                }
            })
		},
		// 选快递公司
		confirmKuaidi(value){
			this.logistics_name = value.name
			this.kuaidi_picker = false
		},
		// 确认发货
		sendOrder(){
            var that = this
			if(!this.logistics_name){
				this.$toast('请选择快递公司')
				return
			}
			if(!this.logistics_code){
				this.$toast('请填写快递单号')
				return
			}
			var params = {
				token: this.token,
				id: this.id,
				logistics_code: this.logistics_code,
				logistics_name: this.logistics_name
			}
			if(this.shop_mark){
				params.shop_mark = this.shop_mark
			}
			this.$api.tradesman.ordership(params).then(res=>{
				if(res.code == 200){
					that.$toast('发货成功')
					that.showFahuo_overlay = false
					that.getData()
				}else{
					that.$toast(res.message)
                    that.showFahuo_overlay = false
                    that.getData()
				}
			})
		},
		// 联系客户
		toContactUser(){
            var that = this
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo",memberParams,(data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                        var params = {
                            token: this.token,
                            uuid: that.info.userdata.uuid
                        };
                        that.$api.xiaoxi.userInfo(params).then(res => {
                            if (res.code == 200) {
                                var tradesmanInfo = res.result;
                                // console.log('创建了与匠人的通信')
                                // that.$parent.sendMsgToTradesman('与' + that.tradesmanInfo.username + '建立了通信', that.mine.userId, that.tradesmanInfo.im_username);

                                that.toAppServe(tradesmanInfo);
                            }
                        })
                    }
                });
            } else {
                var that = this
                that.$router.push({
                    path: '/tradesman/chat',
                    query:{
                        uuid: that.info.userdata.uuid // 客户的uuid
                    }
                })
            }
			
        },
        toAppServe(tradesmanInfo) {
            var nickname = tradesmanInfo.userdata.nickname
            if (nickname == null || nickname == '' || nickname == undefined) {
                nickname = $publicData.formatPhone(tradesmanInfo.userdata.username)
            }
            console.log('tradesmanInfo:',tradesmanInfo)
            var params = {
                data: {
                    toId: tradesmanInfo.im_username,
                    conversationId: tradesmanInfo.im_username,
                    toAvator: tradesmanInfo.userdata.thumb,
                    toPhone: '',
                    toName: nickname,
                    toUUID: tradesmanInfo.userdata.uuid,
                },
            }
            this.$bridge.callhandler("sdjy://public/chat",params,(data) => {

            });
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
	.page .price .payStatus{
		font-size: .24rem;
	}
</style>
